import type { SiteListEntity } from '@common/types/site.type';

import { createActionGroup, props, emptyProps } from '@ngrx/store';

const SitesActions = createActionGroup({
    source: 'Sites/Collection/API',
    events: {
        'Load Collection Request': emptyProps(),
        'Load Collection Success': props<{ sites: SiteListEntity[] }>(),
        'Load Collection Failure': props<{ error: string }>(),
    },
});

export default SitesActions;
